define(['app', './base'], function (app, Helper) {
  return Helper.extend({
    events: {
      click: 'showReport'
    },

    showReport: function () {
      var url = '/post/report?postid=' + this.$el.data('post')
      app.events.commands.execute('modal:report:content', url)
    }
  })
})
